import { render } from "./DefaultTitleScreen.vue?vue&type=template&id=43421d1d&bindings={\"title\":\"data\",\"subtitle\":\"data\",\"picture\":\"data\"}"
import script from "./DefaultTitleScreen.vue?vue&type=script&lang=js"
export * from "./DefaultTitleScreen.vue?vue&type=script&lang=js"

import "./DefaultTitleScreen.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script